import globalActionTypes from './global.type';

export const toggleTheme=(theme)=>({
    type:globalActionTypes.TOGGLE_THEME,
    payload:theme
});

export const loaderStart = (loading) =>({
    type: globalActionTypes.LOADER_START,
    payload: loading
});


export const loaderRemove = (loading) =>({
    type: globalActionTypes.LOADER_REMOVE,
    payload: loading
});

export const loaderMiniStart = (loading) => ({
    type: globalActionTypes.LOADER_MINI_START,
    payload: loading
});


export const loaderMiniRemove = (loading) => ({
    type: globalActionTypes.LOADER_MINI_REMOVE,
    payload: loading
});

export const errorInit = ({error, errorType}) => ({
    type: globalActionTypes.ERROR,
    payload: error,
    errorType: errorType
})

export const messageInit = ({message, messageType}) => ({
    type: globalActionTypes.MESSAGE,
    payload: message,
    messageType: messageType
})


export const clearGlobalState = () => ({
    type: globalActionTypes.CLEAR_GLOBAL_STATE
});